import React from 'react'
import Image from './img/customer-service.webp'
import './content.scss'

export default function EmeraldContactSection() {
  return (
    <div className="ltcob">
      <div className="container">
        {/* <!--            <div className="ltcob__bgdimage">-->
            <!--                <img src="assets/img/logo-bgd.png" alt=""/>-->
            <!--            </div>--> */}
        <div className="ltcob__block">
          <div className="ltcob__left">
            <div className="ltcob__image">
              <img src={Image} alt="customer service" loading="lazy" />
            </div>
          </div>
          <div className="ltcob__right">
            <div className="ltcob__titles">
              <h2 className="ltcob__title">Let's take care of business</h2>
              <a href="/contactus" className="home-btn home-btn--grey home-btn--small">
                CONTACT A SALES REP
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
